import { z } from "zod";
import { isValidIban, normalizeIban } from "../utils/iban";

export const InvoicingFrequencyEnum = z.enum(["weekly", "monthly"]);
export const PaymentMethodEnum = z.enum(["card", "sepa"]);
export const CardTypeEnum = z.enum(["visa", "mastercard", "applepay"]);

export const Step4Schema = z
  .object({
    invoicingFrequency: InvoicingFrequencyEnum,
    paymentMethod: PaymentMethodEnum,
    cardType: CardTypeEnum.optional(),

    sepaAuthorization: z.boolean().optional(),
    accountHolderName: z.string().optional(),
    iban: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.paymentMethod === "card" && !data.cardType) {
      ctx.addIssue({
        path: ["cardType"],
        code: z.ZodIssueCode.custom,
        message: "onboarding.validation.cardTypeRequired",
      });
    }

    if (data.paymentMethod !== "sepa") return;

    if (data.sepaAuthorization !== true) {
      ctx.addIssue({
        path: ["sepaAuthorization"],
        code: z.ZodIssueCode.custom,
        message: "onboarding.validation.sepaAuthorizationRequired",
      });
    }

    const name = (data.accountHolderName ?? "").trim();
    if (!name) {
      ctx.addIssue({
        path: ["accountHolderName"],
        code: z.ZodIssueCode.custom,
        message: "onboarding.validation.accountHolderNameRequired",
      });
    }

    const iban = normalizeIban(data.iban ?? "");
    if (!iban) {
      ctx.addIssue({
        path: ["iban"],
        code: z.ZodIssueCode.custom,
        message: "onboarding.validation.ibanRequired",
      });
      return;
    }

    if (!isValidIban(iban)) {
      ctx.addIssue({
        path: ["iban"],
        code: z.ZodIssueCode.custom,
        message: "onboarding.validation.ibanInvalidFormat",
      });
    }
  });

export type Step4Input = z.infer<typeof Step4Schema>;
